import ControlCardLog from '@/models/ControlCardLog/ControlCardLog';

export default class ControlCardLogFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.controlCardId = '';
		this.controlCardControlCardNumber = '';
		this.transactionType = '';
		this.transaction = '';
		this.qtyBefore = '';
		this.qtyAfter = '';
		this.areaBeforeId = '';
		this.areaBeforeCode = '';
		this.areaAfterId = '';
		this.areaAfterCode = '';
		this.rackBeforeId = '';
		this.rackBeforeCode = '';
		this.rackAfterId = '';
		this.rackAfterCode = '';
		this.controlCardStatusId = '';
		this.controlCardStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		this.notRackBefore = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			controlCardId: '0',
			controlCardControlCardNumber: '0',
			transactionType: '0',
			transaction: '0',
			qtyBefore: '0',
			qtyAfter: '0',
			areaBeforeId: '0',
			areaBeforeCode: '0',
			areaAfterId: '0',
			areaAfterCode: '0',
			rackBeforeId: '0',
			rackBeforeCode: '0',
			rackAfterId: '0',
			rackAfterCode: '0',
			controlCardStatusId: '0',
			controlCardStatusName: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			notRackBefore: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}